import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { COMPANY } from '../data/mock';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-md bg-[#5d728c] flex items-center justify-center text-white font-serif font-bold">EC</div>
              <span className="font-serif text-xl text-white">{COMPANY.name}</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Premium office supplies that keep your workspace running smoothly. Trusted by businesses across the country.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Shop</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/shop-all" className="hover:text-white transition-colors">All Products</Link></li>
              <li><Link to="/shop-all?cat=office-furniture" className="hover:text-white transition-colors">Office Furniture</Link></li>
              <li><Link to="/shop-all?cat=electronics" className="hover:text-white transition-colors">Electronics</Link></li>
              <li><Link to="/shop-all?cat=desk-accessories" className="hover:text-white transition-colors">Desk Accessories</Link></li>
              <li><Link to="/shop-all?cat=writing-tools" className="hover:text-white transition-colors">Writing Tools</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Information</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/checkout" className="hover:text-white transition-colors">Checkout</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 text-[#a3b3c4] shrink-0" />
                <a href={`tel:${COMPANY.phone}`} className="hover:text-white transition-colors">{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 text-[#a3b3c4] shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors break-all">{COMPANY.email}</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-[#a3b3c4] shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {COMPANY.corp}. All rights reserved.</p>
          <p>{COMPANY.name} — Quality office supplies for productivity and organization.</p>
        </div>

        <p className="mt-4 text-xs text-slate-500" data-testid="footer-billing-descriptor">
          Charges will appear as &quot;8337224069ecofficehub&quot; on your credit card statement.
        </p>
      </div>
    </footer>
  );
}
